export const CAR_ORDER_FETCH_DATA = "car_order/car_order_fetch_data"
export const CAR_ORDER_DATA_SUCCESS = "car_order/car_order_fetch_data_success"
export const CAR_ORDER_DATA_FAILURE = "car_order/car_order_fetch_data_failure"
export const CAR_ORDER_FETCH_FILTER = "car_order/car_order_fetch_filter"
export const SHIPPER_TRACKS_FETCH_DATA = "car_order/shipper_tracks_fetch_data"
export const SHIPPER_TRACKS_DATA_SUCCESS =
    "car_order/shipper_tracks_fetch_success"
export const SHIPPER_TRACKS_DATA_FAILURE =
    "car_order/shipper_tracks_fetch_failure"
export const SAVE_CAR_ORDER_QUALITY = "car_order/save_car_order_quality"
export const SAVE_CAR_ORDER_QUALITY_SUCCESS =
    "car_order/save_car_order_quality_success"
export const SAVE_CAR_ORDER_QUALITY_FAILURE =
    "car_order/save_car_order_quality_failure"
export const CAR_ORDER_PATTERNS_FETCH_DATA =
    "car_order/car_order_patterns_fetch_data"
export const CAR_ORDER_PATTERNS_DATA_SUCCESS =
    "car_order/car_order_patterns_fetch_data_success"
export const CAR_ORDER_PATTERNS_DATA_FAILURE =
    "car_order/car_order_patterns_fetch_data_failure"
